/***
 * Model that represents an activities weather information.
 */
import Backbone from 'backbone';

var WellnessDeviceInfo = Backbone.Model.extend({
    backend: 'gcapi',
    urlRoot: '/wellness-service/wellness/deviceInfo/',

    idAttribute: 'deviceId'
});

export default WellnessDeviceInfo;
